import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { mdmAvailableOsUpdatesFeatureKey, mdmAvailableOsUpdatesReducer } from './mdm-available-os-updates.reducer';
import { EffectsModule } from '@ngrx/effects';
import { MdmAvailableOsUpdatesEffects } from './mdm-available-os-updates.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(mdmAvailableOsUpdatesFeatureKey, mdmAvailableOsUpdatesReducer),
    EffectsModule.forFeature([MdmAvailableOsUpdatesEffects]),
  ],
  providers: [],
})
export class MdmAvailableOsUpdatesStoreModule {}
